import { DataList, DataItem } from '@cad-arc'
import { useMinutesAgo } from '../../common/hooks/use-minutes-ago';
import { getFormattedDate } from '../../queues/utils/get-formatted-date';

export function PatrolStartTimeDisplay({
    createdDateUtc,
}: {
    createdDateUtc: string;
}): React.ReactElement {
    const patrolCreatedMinutesAgoDisplay = useMinutesAgo(createdDateUtc);
    return (
        <DataList>
            <DataItem dataKey="Start">
                {`${getFormattedDate(createdDateUtc)}, ${patrolCreatedMinutesAgoDisplay}`}
            </DataItem>
        </DataList>
    );
}
